import HeaderController from './Layout/Header/Controller/HeaderController';

document.addEventListener('DOMContentLoaded', () => {
    new HeaderController();
});
